var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 16.2L40 18.95L35 23.7V40H42C43.657 40 45 38.6569 45 37V16.2Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.2L6.614 17.91L13 23.7V40H6C4.343 40 3 38.6569 3 37V16.2Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.2L24 19.45L13 11.2L12 17L13 23.7L24 31.95L35 23.7L36 17L35 11.2Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.298V16.2L13 23.7V11.2L9.876 8.859C9.132 8.301 8.228 8 7.298 8C4.924 8 3 9.924 3 12.298Z",
    fill: "#C62828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 12.298V16.2L35 23.7V11.2L38.124 8.859C38.868 8.301 39.772 8 40.702 8C43.076 8 45 9.924 45 12.298Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.7d19f683f5f65d08ed7337538102bc24.svg";
export { ForwardRef as ReactComponent };